import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore, useGuestStore, useHotelAdminStore } from '../store'

interface ProtectedRouteProps {
  children: React.ReactNode
  requireGuest?: boolean
  requireAdmin?: boolean
}

/**
 * Компонент для защиты маршрутов
 * - Требует авторизацию (token)
 * - Опционально: требует активного гостя
 * - Опционально: требует админа отеля
 */
export function ProtectedRoute({ children, requireGuest = false, requireAdmin = false }: ProtectedRouteProps) {
  const token = useAuthStore((state) => state.token)
  const guest = useGuestStore((state) => state.guest)
  const admin = useHotelAdminStore((state) => state.admin)

  // Если нет токена - редирект на логин админа или гостя
  if (!token) {
    return <Navigate to="/admin-login" replace />
  }

  // Если требуется админ, но его нет - редирект на логин админа
  if (requireAdmin && !admin?.id) {
    return <Navigate to="/admin-login" replace />
  }

  // Если требуется гость, но его нет - редирект на главную
  if (requireGuest && !guest?.id) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
